/**
* this is the overlay component
* it is only visible when the sidemenu is opened
*
* Created by Tom on 30/5/17
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import cx from 'classnames'

// action import
import { ActionCreator } from '../../actions/'

// style import
import './style.scss'


class Overlay extends Component {

    _closeClick() {
        const { setOpenLeftMenu, setOpenRightMenu } = this.props
        // open the left menu
        setOpenLeftMenu(false)
        setOpenRightMenu(false)
    }

    render() {
        const { openLeftMenu, openRightMenu } = this.props

        const dynClass = cx(
            'overlay',
            { 'overlay--show': (openLeftMenu || openRightMenu) }
        )

        return (
            <div
                className={dynClass}
                onClick={::this._closeClick}>
            </div>
        )


    }
}

// define the prop types
Overlay.propTypes = {
    setOpenLeftMenu: PropTypes.func.isRequired,
    setOpenRightMenu: PropTypes.func.isRequired,
    openLeftMenu: PropTypes.bool,
    openRightMenu: PropTypes.bool
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        openLeftMenu: state.componentState.openLeftMenu,
        openRightMenu: state.componentState.openRightMenu
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        setOpenLeftMenu: action.setOpenLeftMenu,
        setOpenRightMenu: action.setOpenRightMenu
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Overlay)



// WEBPACK FOOTER //
// ./src/components/Overlay/index.js